import moment from 'moment';

import { TOOL_LABELS } from '../constants/general';

import type { GetClientAge, GetMissingRecommendedToolsText } from './types/general';

export const getClientAge: GetClientAge = (dob, dateOfAssessment) => {
  const clientDob = moment(dob);
  return moment(dateOfAssessment).diff(clientDob, 'years');
};

export const getMissingRecommendedToolsText: GetMissingRecommendedToolsText = (
  missingMandatoryTools,
) => {
  const toolNames = missingMandatoryTools.map((tool) => TOOL_LABELS[tool]);
  return toolNames.join(', ');
};
